import { Component, ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { captureError } from "@/lib/monitoring";

interface Props {
  children: ReactNode;
}
interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: { componentStack: string }) {
    console.error("App crashed:", error, info);
    captureError(error, { componentStack: info.componentStack });
  }

  reset = () => {
    this.setState({ error: null });
    window.location.assign("/");
  };

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen grid place-items-center bg-background px-4">
        <div className="max-w-md text-center space-y-4">
          <div className="text-6xl">⚠️</div>
          <h1 className="text-2xl font-bold">Něco se nepovedlo</h1>
          <p className="text-muted-foreground text-sm">
            Aplikace narazila na neočekávanou chybu. Zkuste obnovit stránku — pokud
            problém přetrvává, dejte nám vědět.
          </p>
          {import.meta.env.DEV && (
            <pre className="text-xs text-left bg-muted p-3 rounded overflow-auto max-h-48">
              {this.state.error.message}
            </pre>
          )}
          <Button onClick={this.reset}>Zpět na úvod</Button>
        </div>
      </div>
    );
  }
}
